import React from 'react'

export default function ProjectEmbed(props) {
    return (
        <div className='project-embed project-tiles'>
            <div className='banner'>
                MISC WORKS
            </div>
            <div className='tile-content'>
                <div className='tile-akira' />
                <div className='tile-cmlogo' />
                <div className='tile-vfx' />
                <div className='tile-bohemia' />
                <div className='tile-anticipation' />
                <div className='tile-robot-arms' />
                <div className='tile-robot-kun' />
                <div className='tile-rr' />
                <div className='tile-rr-dark' />
                <div className='tile-st-jam' />
                <div className='tile-earthbender' />
                <div className='tile-exaggeration' />
                <div className='tile-follow-through' />
                <div className='tile-calisthenics' />

                <div className='tile-secondary-action' />
                <div className='tile-slow-inout' />
                <div className='tile-squash-hands' />
                <div className='tile-staging' />

                <div className='tile-clouds' />

            </div>
        </div>
    )
}
